module.exports = __webpack_public_path__ + "static/media/1Asset 306@4x.2f2b5618.png";